(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventura-cartbar"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-vcb]');
    if (!bar) return;

    if (document.querySelector('[data-vp-sticky]')) {
      bar.remove();
      return;
    }

    var counter = bar.querySelector('[data-vcb-count]');

    function render(count) {
      if (counter) counter.textContent = count;
      bar.hidden = !count || count === 0;
    }

    function refresh() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) { render(cart.item_count); })
        .catch(function () {});
    }

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refresh();
    });

    var cartLink = document.querySelector('.vh-cart');
    if (cartLink && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        var badge = cartLink.querySelector('.vh-count');
        var value = badge ? parseInt(badge.textContent, 10) : 0;
        render(isNaN(value) ? 0 : value);
      });
      observer.observe(cartLink, { childList: true, subtree: true, characterData: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventura-footer"]) return;
  try {
    
  (function () {
    var wide = window.matchMedia('(min-width: 750px)');
    function sync() {
      document.querySelectorAll('[data-vf-acc]').forEach(function (item) {
        if (wide.matches) item.setAttribute('open', '');
        else item.removeAttribute('open');
      });
    }
    sync();
    if (wide.addEventListener) wide.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ventura-header"]) return;
  try {
    
  (function () {
    var button = document.getElementById('vh-menu-button');
    var panel = document.getElementById('vh-menu');
    if (!button || !panel) return;
    var close = document.getElementById('vh-menu-close');

    function open() {
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Menu sluiten');
      document.body.style.overflow = 'hidden';
      (close || panel.querySelector('a')).focus();
    }

    function shut() {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Menu openen');
      document.body.style.overflow = '';
      button.focus();
    }

    button.addEventListener('click', function () {
      if (panel.hidden) open();
      else shut();
    });

    if (close) close.addEventListener('click', shut);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) shut();
    });

    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var items = panel.querySelectorAll('a[href], button, summary');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
